import { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import { Menu, MenuItem, Paper, Popper } from "@mui/material";

export function MiActionMenu({
  open,
  selectedActionRow,
  rowActions,
  handleClose,
  anchorEl,
  rowKey = "",
}) {
  const { classes } = useStyles();
  const [popperAnchor, setPopperAnchor] = useState(null);
  const [activeAction, setActiveAction] = useState(null);

  const handleMouseEnter = (event, action) => {
    if (action.popperContent) {
      setPopperAnchor(event.currentTarget);
      setActiveAction(action);
    }
  };

  const handleMouseLeave = () => {
    setPopperAnchor(null);
    setActiveAction(null);
  };

  return (
    <>
      <Menu
        data-testid="MiAction-Menu"
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
      >
        {rowActions.map(
          (action, index) =>
            !action.hide && (
              <MenuItem
                key={`MiAction-MenuItem-${action.name ?? index}-${rowKey}`}
                className={classes.item}
                disabled={action.disabled}
                data-testid={`MiAction-MenuItem-${action.text}`}
                onClick={() =>
                  !action.disabled && action.onClick(selectedActionRow)
                }
                onMouseEnter={(e) => handleMouseEnter(e, action)}
                onMouseLeave={handleMouseLeave}
              >
                {action.renderIcon && action.renderIcon(selectedActionRow)}
                {action.text}
              </MenuItem>
            )
        )}
      </Menu>

      <Popper
        open={Boolean(popperAnchor) && Boolean(activeAction?.popperContent)}
        anchorEl={popperAnchor}
        placement="right"
        className={classes.popper}
      >
        <Paper className={classes.popperPaper}>
          {activeAction?.popperContent}
        </Paper>
      </Popper>
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    // this is needed to show popper when the menu item is disabled
    "&.Mui-disabled": {
      pointerEvents: "auto",
      cursor: "not-allowed",
    },
  },
  popper: {
    zIndex: theme.zIndex.popper,
  },
  popperPaper: {
    padding: theme.spacing(3),
    maxWidth: 300,
  },
}));

MiActionMenu.propTypes = {
  open: PropTypes.bool,
  selectedActionRow: PropTypes.object,
  rowActions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      popperContent: PropTypes.node,
      hide: PropTypes.bool,
      disabled: PropTypes.bool,
      renderIcon: PropTypes.func,
      onClick: PropTypes.func,
    })
  ),
  handleClose: PropTypes.func,
  anchorEl: PropTypes.object,
  rowKey: PropTypes.string,
};
